export default function Footer() {
  return (
    <footer className="bg-neutral-900 text-white/50 py-8 text-center text-[0.78rem]">
      <strong className="text-white/80">Neighbourhood Munchies</strong>
      {' '}·{' '}
      © {new Date().getFullYear()}
    </footer>
  )
}
